import axios from '../../../../utils/request';

function GET_DATA(params) {
    return axios.get("/member/AMemberSetting/index",{  } )
}
function SUBMIT_ADD(params) {
    return  axios.post("/member/AMemberSetting/editPost",{...params} )
}


export default {
    GET_DATA,
    SUBMIT_ADD,

};